import React from 'react';

import { cn } from '@/lib/utils';

const severityMap = {
  critical: 'bg-red-500/20 text-red-400',
  high: 'bg-orange-500/20 text-orange-400',
  medium: 'bg-yellow-500/20 text-yellow-400',
  low: 'bg-blue-500/20 text-blue-400',
  info: 'bg-slate-500/20 text-slate-400',
};

export default function SeverityBadge({ severity = 'info' }) {
  const normalized = String(severity).toLowerCase();

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium capitalize',
        severityMap[normalized] || severityMap.info
      )}
    >
      {normalized}
    </span>
  );
}
